<template>
  <v-dialog v-model="show" persistent max-width="80%">
    <Card>
      <v-card-text style="max-height: 80vh; overflow-y: auto;">
        <v-row v-if="!isViewMode">
          <v-col cols="12" md="10">
            <span class="titulo-redencion">Solicitud</span>
            <span class="titulo-header">Crear Solicitud</span>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" md="10">
            <span class="titulo-redencion"
              >Solicitud # {{ solicitudLocal.id }}</span
            >
            <span class="titulo-header"> {{ solicitudLocal.titulo }}</span>
          </v-col>
        </v-row>

        <div v-if="isViewMode">
          <InfoCards :infoCards="infoCards" @getData="updateView" />
        </div>

        <div>
          <div ref="generalSection">
            <GeneralForm
              :key="mode + (solicitudLocal.id || Math.random())"
              :mode="genMode"
              :solicitud="solicitudLocal"
              :campaniasRaw="campaniasRaw"
              :tiposSolicitud="tiposSolicitud"
              :productosAseguradora="productosAseguradora"
              @clientRelation="clientRelation"
              @onSubmit="handleGeneralSubmit"
            />
          </div>

          <div ref="clienteSection">
            <ClienteForm
              :key="mode + (solicitudLocal.id || Math.random())"
              :mode="clientMode"
              :solicitud="solicitudLocal"
              @onSubmit="saveClient"
              @onCancel="stepBack"
              :clientSave="clientSave"
            />
          </div>

          <div v-if="isViewMode">
            <SeguimientoForm :solicitud="solicitudLocal" />
          </div>
        </div>
        <v-row class="mt-6" justify="end">
          <v-col cols="auto" class="text-right">
            <v-btn
              rounded
              color="#b11f1f"
              dark
              @click="cancelar"
              :disabled="loading"
            >
              Cancelar
            </v-btn>
            <v-btn
              rounded
              dark
              color="#b11f1f"
              class="ml-2"
              @click="saveSolicitud"
              :loading="loading"
              :disabled="loading"
              v-if="!isViewMode && !insertedSolicitud"
            >
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </Card>
  </v-dialog>
</template>

<script>
import InfoCards from "@/components/solicitudes/InfoCards.vue";
import GeneralForm from "@/components/solicitudes/forms/GeneralForm.vue";
import ClienteForm from "@/components/solicitudes/forms/ClienteForm.vue";
import SeguimientoForm from "@/components/solicitudes/forms/SeguimientoForm.vue";
import { getAllCampaniasPostVenta } from "@/services/campaniasPostventa";
import { mainAxios } from "@/mainAxios";

import Card from "@/components/commondComponents/Card.vue";
import { createSolicitudManual } from "@/services/solicitudService";

export default {
  components: { GeneralForm, ClienteForm, SeguimientoForm, Card, InfoCards },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "create",
    },
    solicitud: {
      type: Object,
      default: () => ({}),
    },
    ignoreClientStep: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    solicitud: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.solicitudLocal = JSON.parse(JSON.stringify(newVal || {}));
        this.mapSolicitudToInfoCards();
      },
    },
    mode: {
      immediate: true,
      handler(newMode) {
        this.genMode = newMode;
      },
    },
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
    insertedSolicitud() {
      return this.genMode === "create";
    },
  },
  async mounted() {
    await this.loadCampanias();
    this.getProductosAseguradora();
  },
  data() {
    return {
      solicitudLocal: {},
      clientSave: false,
      loading: false,
      genMode: "",
      clientMode: "view",
      campaniasRaw: [],
      tiposSolicitud: [],
      productosAseguradora: [],
      infoCards: {
        notas: [],
        docs: [],
        logs: [],
      },
    };
  },
  methods: {
    cancelar() {
      this.solicitudLocal = {};
      this.clientSave = false;
      this.loading = false;

      this.$emit("close");
      this.$emit("reset");

      this.$nextTick(() => {
        if (this.$refs.generalSection && this.$refs.generalSection.resetForm) {
          this.$refs.generalSection.resetForm();
        }
        if (this.$refs.clienteSection && this.$refs.clienteSection.resetForm) {
          this.$refs.clienteSection.resetForm();
        }
      });
    },

    handleGeneralSubmit(data) {
      this.genMode = "view";
      this.solicitudLocal = { ...data };
      if (this.ignoreClientStep === false) {
        this.clientMode = "create";
        this.clientSave = true;
      }

      const section = this.$refs.clienteSection;
      if (section) section.scrollIntoView({ behavior: "smooth" });
    },
    stepBack() {
      this.genMode = "create";
      const section = this.$refs.generalSection;
      if (section) section.scrollIntoView({ behavior: "smooth" });
    },
    saveClient(cliente) {
      this.solicitudLocal = {
        ...this.solicitudLocal,
        ...cliente,
      };
      this.clientSave = false;
      this.clientMode = "view";
    },
    clientRelation(partialUpdate) {
      this.solicitudLocal = { ...this.solicitudLocal, ...partialUpdate };
    },

    async saveSolicitud() {
      this.loading = true;
      const data = {
        ...this.solicitudLocal,
        fromExcepcion: false,
        origen: "Portal",
        redimirBeneficioAsistencia: false,
        status: 1,
        correo: this.solicitudLocal.correoElectronico,
        telefono: this.solicitudLocal.celularMovil,
        relationName: this.solicitudLocal.relationName,
        relationType: this.solicitudLocal.relationType,
        relationId: this.solicitudLocal.relation,
      };

      switch (this.solicitudLocal.relationType) {
        case "Poliza":
          data.emisionId = this.solicitudLocal.relation;
          break;
        case "Solicitud":
          data.solicitudId = this.solicitudLocal.relation;
          break;
        case "Cliente":
          data.clienteId = this.solicitudLocal.relation;
          break;
        case "Lead":
          data.leadId = this.solicitudLocal.relation;
          break;
      }

      try {
        const res = await createSolicitudManual(data);

        if (res.status === 200) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.push(`/solicitud/${res.data.solicitud.id}`);
          }, 1500);
        } else {
          this.$toast.info(res.message);
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Ocurrió un error al crear la redención");
      } finally {
        this.loading = false;
      }
    },
    mapSolicitudToInfoCards() {
      const documentos = this.solicitudLocal.documentos || [];
      const logs = this.solicitudLocal.logs || [];

      this.infoCards = {
        notas: documentos.filter((doc) => doc.tipoRegistro === "Nota"),
        docs: documentos.filter((doc) => doc.tipoRegistro === "Documento"),
        logs: logs,
      };
    },
    async loadCampanias() {
      try {
        const res = await getAllCampaniasPostVenta();
        this.campaniasRaw = res || [];
        this.tiposSolicitud = [
          ...new Set(this.campaniasRaw.map((c) => c.tipificacion)),
        ];
      } catch (error) {
        console.error("Error al cargar campañas:", error);
      }
    },
    getProductosAseguradora() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };
      mainAxios
        .get("v1/producto/productosAseguradora", config)
        .then((response) => {
          this.productosAseguradora = response.data.data.productos;
        });
    },
    updateView() {
      location.reload();
    },
  },
};
</script>

<style scoped>
.titulo-redencion {
  font-weight: 700;
  font-size: 32px;
  color: #130707;
  display: block;
  padding-bottom: 5px;
}
.titulo-header {
  font-weight: 600;
  font-size: 20px;
  display: block;
  margin-top: 4px;
}
</style>
